import {Modal} from 'react-bootstrap'
import {KTSVG} from '../../../../../_metronic/helpers'
import SVG from 'react-inlinesvg'
import React from 'react'
import '../SenderId.scss'

interface Props {
  show: boolean
  handleClose: () => void
  onClickActionButton?: () => void
  showActionButton: boolean
}

const ModalDetailCustomBusiness: React.FC<Props> = ({
  show,
  handleClose,
  onClickActionButton,
  showActionButton,
}) => {
  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName='modal-sender-id-learn-more modal-dialog-centered mw-900px'
        fullscreen={'lg-down'}
      >
        <div className='modal-header'>
          <h2 className='fs-2'>Custom Business Name</h2>
          <div className='btn btn-icon btn-sm' onClick={handleClose}>
            <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
          </div>
        </div>
        <div className='modal-body'>
          <div className='row'>
            <div className='col-md-6'>
              <p className='mb-4'>
                Build trust and recognition by sending SMS with your business name instead of a
                random number. This ensures your messages are instantly recognizable, professional,
                and aligned with your brand identity.
              </p>

              <h4 className='fw-bolder mb-3'>Perfect For</h4>
              <ul className='list-unstyled'>
                <li className='mb-2'>
                  <div className='d-flex'>
                    <div className='me-2'>
                      <SVG src='/media/svg/check.svg' style={{width: '100%'}} />
                    </div>
                    <div>Brand awareness & promotions</div>
                  </div>
                </li>
                <li className='mb-2'>
                  <div className='d-flex'>
                    <div className='me-2'>
                      <SVG src='/media/svg/check.svg' style={{width: '100%'}} />
                    </div>
                    <div>Professional & official messaging</div>
                  </div>
                </li>
                <li className='mb-2'>
                  <div className='d-flex'>
                    <div className='me-2'>
                      <SVG src='/media/svg/check.svg' style={{width: '100%'}} />
                    </div>
                    <div>No random numbers—just your trusted brand</div>
                  </div>
                </li>
                <li className='mb-2'>
                  <div className='d-flex'>
                    <div className='me-2'>
                      <SVG src='/media/svg/check.svg' style={{width: '100%'}} />
                    </div>
                    <div>AI chatbot-ready – Automate & scale conversations</div>
                  </div>
                </li>
              </ul>

              <h4 className='fw-bolder mb-3'>Things to note:</h4>
              <ul className='list'>
                <li className='mb-2'>
                  This feature supports one-way messaging—customers won’t be able to reply.
                </li>
                <li className='mb-2'>
                  Some Android devices may filter these messages, so test before launching large
                  campaigns.
                </li>
              </ul>
            </div>
            <div className='col-md-6 justify-content-center align-items-center d-flex'>
              <div className='card rounded-4 overflow-hidden'>
                <iframe
                  width='417'
                  height='240'
                  src='https://www.youtube.com/embed/9jw1ydbonhY'
                  allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
                  referrerPolicy='strict-origin-when-cross-origin'
                  allowFullScreen
                ></iframe>
              </div>
            </div>
          </div>
        </div>
        <div className='modal-footer border-top-0 d-flex justify-content-end text-end'>
          {showActionButton && (
            <button
              type='button'
              className='btn btn-lg px-5 py-3 text-white fw-bolder'
              style={{backgroundColor: '#6C5CE7', borderRadius: '8px'}}
              onClick={onClickActionButton}
            >
              Register business name
            </button>
          )}
        </div>
      </Modal>
    </>
  )
}

export default ModalDetailCustomBusiness
